"use strict";
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
exports.alarmUiTranslations = {
    "en-GB": {
        "alarmlist": {
            "datachangeNotAvailable": "Data change is not available!",
            "listOf": "List of",
            "numberOfAlarms": "alarms:  Number of alarms is {0}",
            "penging": "pending",
            "historical": "historical",
            "unit": "Unit",
            "columnHeader": {
                "msc": "Msc",
                "msgNumber": "Msg Number",
                "dateTime": "Date Time",
                "state": "State",
                "text": "Text",
                "ackGroup": "Ack Group",
                "plc": "Plc"
            },
            "state": {
                "0": "CG",
                "1": "C",
                "2": "CAG",
                "3": "CA",
                "4": "G??",
                "5": "???",
                "6": "CGA",
                "7": "???",
            },
            "msgClass": {
                "0": "?",
                "1": "!",
                "2": "",
                "3": "$",
                "4": "S7",
                "33": "CPU:",
                "34": "CPU:",
                "40": "CPU:",
                "65": "!!",
                "10": "",
            }
        }
    },
    "de-DE": {
        "alarmlist": {
            "datachangeNotAvailable": "Datenupdate ist nicht verfügbar!",
            "listOf": "Liste von",
            "numberOfAlarms": "Alarme:  Anzahl der Alarme ist {0}",
            "penging": "anstehenden",
            "historical": "historischen",
            "unit": "Unit",
            "columnHeader": {
                "msc": "Msc",
                "msgNumber": "Msg Number",
                "dateTime": "Date Time",
                "state": "State",
                "text": "Text",
                "ackGroup": "Ack Group",
                "plc": "Plc"
            },
            "state": {
                "0": "KG",
                "1": "K",
                "2": "KQG",
                "3": "KQ",
                "4": "G??",
                "5": "???",
                "6": "KGQ",
                "7": "???",
            },
            "msgClass": {
                "0": "?",
                "1": "!",
                "2": "",
                "3": "$",
                "4": "S7",
                "33": "CPU:",
                "34": "CPU:",
                "40": "CPU:",
                "65": "!!",
                "10": "",
            }
        }
    }
};
